export function isNullOrUndefined(value) {
  return typeof value === 'undefined' || value === null;
}